import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { BankIdPaymentTodoSelectionPanelProps } from "models/propTypes/todoSelectionPanelPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region component
import { FooterWithDivider, TitleWithDescription, TitledContainerInner } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const BankIdPaymentTodoSelection: React.FC<BankIdPaymentTodoSelectionPanelProps> = (props) => {
  return (
    <TitledContainerInner
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.BankIdPaymentsHeader)}
      subHeader={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.BankIdPaymentsSubHeader)}
    >
      <FooterWithDivider>
        <TitleWithDescription
          title={`${LocalizationHelperInstance.getFormattedCurrency(props.selectedPaymentsTotal)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.BankIdMarkedPayments, "", {
            selectedPayments: props.selectedPaymentsCount.toString(),
            allPayments: props.allPaymentsCount.toString(),
          })}
          helpText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.PaymentsTooltipMessage)}
        />
      </FooterWithDivider>
    </TitledContainerInner>
  );
};

export default BankIdPaymentTodoSelection;
